
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/memberships/[membershipId]/reservation",
      function () {
        return require("private-next-pages/memberships/[membershipId]/reservation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/memberships/[membershipId]/reservation"])
      });
    }
  